@if (containsPermanent()) {
	<div id="overlay"></div>
}
<div popover="manual" #mepSnackbar>
	@if (containsPermanent()) {
		<div id="overlay"></div>
	}
	@if (messageService.messages) {
		<div id="snackbar">
			@for (message of messageService.messages | keyvalue; track message) {
				<div
					class="{{ message.value.alert }} mb-4"
					[class.permanent]="message.value.isPermanent"
					[class.warning-light]="isLightModeWarning(message.value.alert)"
				>
					<span [innerHTML]="message.value.message"></span>
					@if (message.value.isPermanent) {
						<mat-icon (click)="deleteMessage(message.key)" class="mat-icon material-icons">cancel</mat-icon>
					}
				</div>
			}
		</div>
	}
